import { render } from "./BtnPrinterMulti.vue?vue&type=template&id=6da5f306"
import script from "./BtnPrinterMulti.vue?vue&type=script&lang=ts"
export * from "./BtnPrinterMulti.vue?vue&type=script&lang=ts"
script.render = render

export default script